import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

import './CompetitionRoundRobin.css'; // Import the updated styles for the form
import useAxios from '../../useAxios';

import Select from 'react-select';

const CompetitionRoundRobin = forwardRef(({ competition, id }, ref) => {

  const [axios] = useAxios(true);

  // Get user type from session storage
  const getUserType = () => {
    const token = sessionStorage.getItem("token");
    if (!token) return "user";
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.user_type || "user";
    } catch {
      return "user";
    }
  };

  const isAdmin = getUserType() === "admin";

  const [players, setPlayers] = useState(null);
  const [playerToAdd, setPlayerToAdd] = useState(null);
  const [roundRobin, setRoundRobin] = useState(null);

  const scoreSystems = [{id: "winner1draw0", name: "Winner +1 / Draw +0"}, {id: "winner3draw1", name: "Winner +3 / Draw +1"}, {id: "frame", name: "Points each frame"}];

  useEffect(() => {
    axios.get('players', setPlayers)
    axios.get('competitionroundrobin/'+(competition.id??"new"), setRoundRobin)
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRoundRobin((prevcomp) => ({ ...prevcomp, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setRoundRobin((prevcomp) => ({ ...prevcomp, [name]: checked }));
  };

  const handleScoreSystemChange = (system) => {
    setRoundRobin((prevcomp) => ({ ...prevcomp, scoreSystem: system }));
  };

  // Helper function to get handicap for a specific game type
  const getHandicapForGameType = (player, gameTypeId) => {
    if (!gameTypeId) {
      return player?.handicap ?? 0;
    }
    // Note: Backend uses 'value' property, not 'handicap'
    const handicapEntry = (player?.handicaps || []).find((h) => h.gameTypeId === gameTypeId);
    return handicapEntry?.value ?? 0;
  };

  const addPlayer = () => {
    const gameTypeId = competition?.gameType?.id;
    const playerWithCorrectHandicap = {
      ...playerToAdd,
      handicap: getHandicapForGameType(playerToAdd, gameTypeId),
    };

    setRoundRobin((prevcomp) => ({ ...prevcomp, players: [...prevcomp.players, playerWithCorrectHandicap]}));
    setPlayerToAdd(null);
  };

  const removePlayer = (p) => {
    setRoundRobin((prevcomp) => ({ ...prevcomp, players: prevcomp.players.filter(x => x.id !== p.id)}));
  };

  const togglePlayerPaid = (playerId, isPaid) => {
    setRoundRobin((prevcomp) => ({
      ...prevcomp,
      players: prevcomp.players.map((player) =>
        player.id === playerId ? { ...player, paid: isPaid } : player
      ),
    }));
  };
  
  const handleOnSave = (competition, next) => {
    roundRobin.competitionId = competition.id;
    axios.post('competitionroundrobin/' + competition.id, roundRobin, next);
  };

  // Expose the function to the parent component through the ref
  useImperativeHandle(ref, () => ({
    onSave: handleOnSave,
  }));

  if (roundRobin === null || players === null)
  {
    return <h1>Loading</h1>;
  }

  return (
        <div className="edit-roundrobin-grid">
          <div className="col1">
            <label>Race To:</label>
            <br />
            <input
                name="raceTo"
                type="number"
                value={roundRobin.raceTo}
                onChange={handleChange}
                min={0}  // Optional: Set minimum value
                max={100}  // Optional: Set maximum value
              />
            <br />
            <br />
            <label>Match Time Limit:</label>
            <br />
            <input
                name="matchTimeLimit"
                type="number"
                value={roundRobin.matchTimeLimit}
                onChange={handleChange}
                min={0}  // Optional: Set minimum value
                max={300}  // Optional: Set maximum value
              />
            <br />
            <br />
            <label>Handicapped:</label>
            <br />
            <input
                name="handicapped"
                type="checkbox"
                value={roundRobin.handicapped}
                onChange={handleCheckboxChange}
              />
            <br />
            <br />
            <label>Number Of Groups:</label>
            <br />
            <input
                name="numberOfGroups"
                type="number"
                value={roundRobin.numberOfGroups}
                onChange={handleChange}
                min={0}  // Optional: Set minimum value
                max={4}  // Optional: Set maximum value
              />
            <br />
            <br />
            <label>Score System:</label>
            <Select
              name="scoreSystem"
              value={roundRobin.scoreSystem}
              onChange={(option) => handleScoreSystemChange(option)}
              options={scoreSystems}
              getOptionValue={(option) => option.id}  // Specify the property used for value
              getOptionLabel={(option) => option.name}  // Specify the property used for label
          isSearchable={false} />
          <br />
          <label>Players:</label>
          <Select
            value={playerToAdd}
            onChange={(option) => setPlayerToAdd(option)}
            options={players.filter(x => {
              // Filter out players already in the competition
              return !roundRobin.players.some(y => y.name === x.name);
            })}
            isClearable={true}
            placeholder="Select a player..."
            getOptionValue={(option) => option.id}  // Specify the property used for value
            getOptionLabel={(option) => `${option.name} (${getHandicapForGameType(option, competition?.gameType?.id)})`}  // Specify the property used for label
            isSearchable={false}
          />
          <button type="button" onClick={addPlayer} disabled={playerToAdd === null}>
            Add
          </button>
          {roundRobin.players.map(x => { return (
            <div style={{height:"50px", display: 'flex', alignItems: 'center'}} key={x.id}>
              <div style={{ flex: 1 }}>
                {x.name} ({getHandicapForGameType(x, competition?.gameType?.id)})
              </div>
              {isAdmin && (
                <label style={{ marginLeft: '12px', marginRight: '8px', display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={x.paid || false}
                    onChange={(e) => togglePlayerPaid(x.id, e.target.checked)}
                    style={{ marginRight: '4px' }}
                  />
                  Paid
                </label>
              )}
              <a className="small-cross" onClick={() => removePlayer(x)}>x</a>
            </div>
          )})}
          </div>
        </div>
  );
});

export default CompetitionRoundRobin;
